module.exports = {
	"ha": "fha",
	"id": 5.3,
	"report": {
		"ha": "Fraser Health",
		"group": "HSDA",
		"period": "2017 Q2–2019 Q1",
		"lastYear": "2019",
		"lastQuarter": "1"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 720,
			"height": 500,
			"marginTop": 60,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.3</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Fraser Health by Age Category, Year Ending 2019 Q1 <sup style=\"font-size: 10px;\">8</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -130,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "70%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "70%",
				"height": "30%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -40,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 79.6875,
						"dataLabels": {
							"enabled": true,
							"format": "102",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 71.875,
						"dataLabels": {
							"enabled": true,
							"format": "92",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 65.625,
						"dataLabels": {
							"enabled": true,
							"format": "84",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 57.03125,
						"dataLabels": {
							"enabled": true,
							"format": "73",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 46.875,
						"dataLabels": {
							"enabled": true,
							"format": "60",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 95.01661129568106,
						"dataLabels": {
							"enabled": true,
							"format": "286",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.38538205980066,
						"dataLabels": {
							"enabled": true,
							"format": "254",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 79.734219269103,
						"dataLabels": {
							"enabled": true,
							"format": "240",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.10299003322258,
						"dataLabels": {
							"enabled": true,
							"format": "208",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 60.797342192691026,
						"dataLabels": {
							"enabled": true,
							"format": "183",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.23655913978494,
						"dataLabels": {
							"enabled": true,
							"format": "537",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 86.91756272401435,
						"dataLabels": {
							"enabled": true,
							"format": "485",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 83.33333333333334,
						"dataLabels": {
							"enabled": true,
							"format": "465",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 75.26881720430107,
						"dataLabels": {
							"enabled": true,
							"format": "420",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 62.903225806451616,
						"dataLabels": {
							"enabled": true,
							"format": "351",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": 96.49805447470817,
						"dataLabels": {
							"enabled": true,
							"format": "1240",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 87.62645914396887,
						"dataLabels": {
							"enabled": true,
							"format": "1126",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 84.90272373540856,
						"dataLabels": {
							"enabled": true,
							"format": "1091",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 80.70038910505836,
						"dataLabels": {
							"enabled": true,
							"format": "1037",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": 69.72762645914396,
						"dataLabels": {
							"enabled": true,
							"format": "896",
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -20.3125,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.80392156862745,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -8.695652173913048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.095238095238093,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -17.808219178082197,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -4.983388704318936,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -11.188811188811187,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -5.511811023622048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.33333333333333,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -12.01923076923077,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.7634408602150504,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.68342644320298,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.123711340206182,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.677419354838712,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -16.428571428571427,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					},
					{
						"y": -3.5019455252918275,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -9.193548387096772,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -3.1083481349911235,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -4.949587534372135,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": -13.596914175506269,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false,
							"style": {
								"fontSize": "9px"
							}
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "< 30<br>n=128"
			},
			{
				"x": 9,
				"text": "30–39<br>n=301"
			},
			{
				"x": 15,
				"text": "40–49<br>n=558"
			},
			{
				"x": 21,
				"text": "≥ 50<br>n=1285"
			}
		],
		"dataTable": {
			"< 30": [
				128,
				102,
				92,
				84,
				73,
				60
			],
			"30–39": [
				301,
				286,
				254,
				240,
				208,
				183
			],
			"40–49": [
				558,
				537,
				485,
				465,
				420,
				351
			],
			"≥ 50": [
				1285,
				1240,
				1126,
				1091,
				1037,
				896
			]
		}
	},
	"callback": "C:\\Users\\Nada\\Documents\\GitHub\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_fha_5_3.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_fha_5_3.json
// module id = 202
// module chunks = 0